import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { makeStyles } from '@material-ui/core/styles';
import LaunchRounded from '@material-ui/icons/LaunchRounded';
import TrendingUpRounded from '@material-ui/icons/TrendingUpRounded';
import { useNavigate } from 'react-router-dom';
import strings from '../../localization';
import { usePage } from '../../utils/page';

const FUFUTURE_URL = 'https://d.fufuture.io';

const ICON_SIZE = 28;

const useStyles = makeStyles((theme) => ({
  iconBadge: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: ICON_SIZE,
    width: ICON_SIZE,
    borderRadius: ICON_SIZE / 2,
    color: '#fff',
    background: 'linear-gradient(135deg, #ffa726 0%, #7c4dff 100%)',
  },
  launchIcon: {
    color: theme.palette.text.secondary,
  },
}));

// iOS gets a plain in-app browser view since the app hides the dapp
// connections flow on that platform.
function openPlainInAppBrowser() {
  const settings: Record<string, string | boolean> = {
    location: true,
    fullscreen: false,
    toolbarposition: 'top',
    navigationbuttoncolor: '#ffffff',
    closebuttoncolor: '#ffffff',
  };

  const settingsString = Object.entries(settings)
    .map(([key, value]) => {
      const serializedValue =
        typeof value === 'boolean' ? (value ? 'yes' : 'no') : value;
      return `${key}=${serializedValue}`;
    })
    .join(',');

  window.cordova.InAppBrowser.open(FUFUTURE_URL, '_blank', settingsString);
}

export default function FuFutureListItem() {
  const classes = useStyles();
  const navigate = useNavigate();
  const [, setPage] = usePage();

  const openFuFuture = () => {
    const platformId = window.cordova?.platformId;

    // Android opens FuFuture through the wallet's dapp browser (same flow as
    // Official Dapps), which injects the provider on load so the user can
    // connect and trade.
    if (platformId === 'android' && window.cordova?.InAppBrowser) {
      setPage('connections');
      navigate('/browser', { state: { url: FUFUTURE_URL } });
      return;
    }

    if (platformId === 'ios' && window.cordova?.InAppBrowser) {
      openPlainInAppBrowser();
      return;
    }

    // Extension and web get a regular browser tab; the extension's content
    // script injects the provider there.
    const newWindow = window.open(FUFUTURE_URL, '_blank');
    if (newWindow) {
      newWindow.opener = null;
    }
  };

  return (
    <ListItem button onClick={openFuFuture}>
      <ListItemIcon>
        <div className={classes.iconBadge}>
          <TrendingUpRounded fontSize="small" />
        </div>
      </ListItemIcon>
      <ListItemText
        primary={strings.fufutureItemTitle}
        primaryTypographyProps={{ style: { fontWeight: 600 } }}
        secondary={strings.fufutureItemSubtitle}
      />
      <LaunchRounded fontSize="small" className={classes.launchIcon} />
    </ListItem>
  );
}

declare global {
  interface Window {
    cordova?: any;
  }
}
